import React from "react";
import cs from "classnames";
import './ExpandBox.scss';

type ExpandBoxProps = {
  children?: JSX.Element | JSX.Element[];
  expandChildren?: JSX.Element | JSX.Element[];
  expand?: boolean;
};

export const ExpandBox = ({ children, expand }: ExpandBoxProps) => {
  return (
    <div className={"c-hex-expand-box-container"}>
      <div
        className={cs("c-hex-expand-box-expand-children", {
          "c-hex-expand-box-expand-open": expand,
        })}
      >
        {children}
      </div>
    </div>
  );
};
